import { StorageEnum } from '@/lib/enum/StorageEnum';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@/util/storageFunctions';
import { v4 as uuidv4 } from 'uuid';

export default {
  namespaced: true,

  state: {
    loading: 0,
    redirectLoading: 0,
    forceReload: 0,
    deviceId: null as string | null,
  },

  getters: {
    isRedirecting(state): boolean {
      return !!state.redirectLoading;
    },

    globalLoading(state, getters): boolean {
      return !!state.loading || getters.isRedirecting;
    },

    forceReload(state): number {
      return state.forceReload;
    },
  },

  mutations: {
    START_LOADING(state) {
      state.loading += 1;
    },
    END_LOADING(state) {
      if (state.loading > 0) {
        state.loading -= 1;
      }
    },

    START_REDIRECT_LOADING(state) {
      state.redirectLoading += 1;
    },
    END_REDIRECT_LOADING(state) {
      if (state.redirectLoading > 0) {
        state.redirectLoading -= 1;
      }
    },

    FORCE_RELOAD(state) {
      state.forceReload += 1;
    },

    SET_DEVICE_ID(state, deviceId: string | null) {
      state.deviceId = deviceId;
    },
  },

  actions: {
    forceReload({ commit }) {
      commit('FORCE_RELOAD');
    },
    initialiseDevice({ commit }) {
      let deviceId = getLocalStorageItem(StorageEnum.DeviceId);

      if (!deviceId) {
        deviceId = uuidv4();
        setLocalStorageItem(StorageEnum.DeviceId, deviceId);
      }

      this.deviceId = deviceId;
      commit('SET_DEVICE_ID', deviceId);
    },
    resetDevice({ commit }) {
      commit('SET_DEVICE_ID', null);
      localStorage.removeItem(StorageEnum.DeviceId);
    },
  },
};
